const trimWhitespace = (str) => {
    // use regex to remove whitespace from right and left of string 
    str = str.replace(/^[ ]+|[ ]+$/g,''); 
    // return result; 
    return str; 
}

export default trimWhitespace; 